import {
    CLEAR_AD,
    FETCH_ADS, FETCH_ADS_SUCCESS, FETCH_ADS_FAILURE,
    SAVE_AD, SAVE_AD_SUCCESS, SAVE_AD_FAILURE,
    EMPTY_ADS, SET_AD, SET_ADS
} from './constants';

import { request, requestConfig } from 'utils/request';
import { PATHS } from 'utils/paths';

export const clearAd = () => ({
    type: CLEAR_AD
});

export const emptyAds = () => ({
    type: EMPTY_ADS
});

const fetchAds = () => ({
    type: FETCH_ADS
});

const fetchAdsSuccess = (data) => ({
    type: FETCH_ADS_SUCCESS,
    data
});

const fetchAdsFailure = (error) => ({
    type: FETCH_ADS_FAILURE,
    error
});

const saveAd = () => ({
    type: SAVE_AD
});

const saveAdSuccess = (data) => ({
    type: SAVE_AD_SUCCESS,
    data
});

const saveAdFailure = (error) => ({
    type: SAVE_AD_FAILURE,
    error
});

export const setAd = (data) => ({
    type: SET_AD,
    data
});

export const setAds = (data) => ({
    type: SET_ADS,
    data
});


/**
 *  ASYNC ACTIONS
 */
export const getAds = () => (dispatch, getStore) => {
    dispatch(fetchAds());

    return request(PATHS.ads.get(), requestConfig('GET', null, getStore().auth.token))
        .then((response) => {
            console.log(response.data);
            dispatch(fetchAdsSuccess(response.data));
            return response;
        })
        .catch((error) => {
            console.log('error saving ads', error);
            error.friendlyMessage = 'There was an error saving these ads. Please try again.';
            dispatch(fetchAdsFailure(error));
            return error;
        });
};

export const putAd = (useViewUrl) => (dispatch, getStore) => {
    dispatch(saveAd());

    let ad = getStore().ads.ad;
    let method = 'PUT';
    let path = PATHS.ads.save(ad.id);

    if(!ad.id) {
        method = 'POST';
        path = PATHS.ads.create();
    }

    if(ad.status == null) {
        ad.status = 'active';
    }

    if(ad.placement == null) {
        ad.placement = 'main';
    }

    /*if(useViewUrl) {
        delete ad.titleCopy;
        delete ad.bodyCopy;
        delete ad.linkUrl;
        delete ad.photoUrl;
    } else {
        delete ad.viewUrl;
    }*/

    return request(path, requestConfig(method, ad, getStore().auth.token))
        .then((response) => {
            console.log(response);
            dispatch(saveAdSuccess(response.data));
            dispatch(getAds());
            return response;
        })
        .catch((error) => {
            console.log('error saving ad', error);
            error.friendlyMessage = 'There was an error saving this ad. Please try again.';
            dispatch(saveAdFailure(error));
            return error;
        });
};



// WEBPACK FOOTER //
// ./src/containers/AdsPage/store/actions.js